import {
	AlertDialog,
	AlertDialogAction,
	AlertDialogCancel,
	AlertDialogContent,
	AlertDialogDescription,
	AlertDialogFooter,
	AlertDialogHeader,
	AlertDialogTitle,
} from "@/components/ui/alert-dialog"
import { Checkbox } from "@/components/ui/checkbox"
import { useState } from "react"

interface ApprovalModalProps {
	open: boolean
	onClose: () => void
	onConfirm: () => void
}

export function ApprovalModal({
	open,
	onClose,
	onConfirm,
}: ApprovalModalProps) {
	const [dontShowAgain, setDontShowAgain] = useState(false)

	const handleConfirm = () => {
		if (dontShowAgain) {
			localStorage.setItem("hideApprovalModal", "true")
		}
		onConfirm()
	}

	return (
		<AlertDialog
			open={open}
			onOpenChange={onClose}
		>
			<AlertDialogContent>
				<AlertDialogHeader>
					<AlertDialogTitle>Confirmar Aprovação</AlertDialogTitle>
					<AlertDialogDescription>
						Tem certeza que deseja aprovar esta inscrição?
					</AlertDialogDescription>
				</AlertDialogHeader>
				<AlertDialogFooter>
					<div className="flex w-full justify-between items-center">
						<div className="flex items-center space-x-2">
							<Checkbox
								id="dont-show-again"
								checked={dontShowAgain}
								onCheckedChange={(checked) => setDontShowAgain(!!checked)}
							/>
							<label
								htmlFor="dont-show-again"
								className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
							>
								Não exibir novamente
							</label>
						</div>
						<div className="flex gap-2">
							<AlertDialogCancel onClick={onClose}>Cancelar</AlertDialogCancel>
							<AlertDialogAction onClick={handleConfirm}>
								Confirmar
							</AlertDialogAction>
						</div>
					</div>
				</AlertDialogFooter>
			</AlertDialogContent>
		</AlertDialog>
	)
}
